/*jshint esversion: 8 */
//{/* use this to comment inside jsx*/}
import './styles/home.css';
import './styles/team.css';
import Image from 'react-bootstrap/Image';
import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import ab from './pix/mail.png';
import mp from './pix/arrow-right-1.png';
import l4 from './pix/l4.svg';
import off from './pix/video-thumbnail.jpg';
import comm from './pix/comm.jpg';
import shake from './pix/shake.jpg';
import contact from './pix/contact.jpg';
import mul from './pix/mul.jpg';
import reach from './util/home/Global-Reach-scaled.jpg'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Accordion from 'react-bootstrap/Accordion';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Navbar from 'react-bootstrap/Navbar';
import Form from 'react-bootstrap/Form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';


{/**logo should be png file, have a transparent background */}

function Team () {
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(false);
    const [aboutUsHover, setAboutUsHover] = useState(false);
    const [strategiesHover, setStrategiesHover] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        document.body.classList.toggle("menu-open", menuOpen);
        // Cleanup: make sure class is removed if the component unmounts
        // while the menu is open (e.g. route change).
        return () => {
            if (menuOpen) document.body.classList.remove("menu-open");
        };
    }, [menuOpen]);

    // Simple toggle for the hamburger button — no more manual DOM calls here.
    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
    };

    // Dedicated close function used by the X button, overlay, and nav items.
    const closeMenu = () => {
        setMenuOpen(false);
    };
    // Add these states for mobile dropdowns (separate from desktop)
    const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
    const [mobileStrategiesOpen, setMobileStrategiesOpen] = useState(false);
    // New State for Scroll Effect
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            // If user scrolls more than 150px, trigger the fixed state
            if (window.scrollY > 150) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
     <div class=''>

    <Navbar id='nav-ham' expanded={expanded} onToggle={() => setExpanded(!expanded)} collapseOnSelect expand="lg" fixed="top" className={`custom-navbar ${scrolled ? 'navbar-fixed-reveal' : ''}`} variant="light">
  <Container className="d-flex w-100 align-items-center justify-content-between" id='nav-con-f'>
  <Navbar.Brand href="/"><Image
                src={l4}
                id='nav-img-og'
                alt="shereen Logo"
            /></Navbar.Brand>

{/* Custom Hamburger Button for mobile */}
  <button
  id='burg'
  className={`hamburger-button ${menuOpen ? "active" : ""}`}
  onClick={toggleMenu}
  aria-label="Menu"
>
  <span className="hamburger-line"></span>
  <span className="hamburger-line"></span>
  <span className="hamburger-line"></span>
</button>

  <Navbar.Collapse id="responsive-navbar-nav" style = {{}}>
    <Nav className="ms-auto align-items-center"  style = {{marginRight: '-10%'}}  >
    <NavDropdown
                    title={
                        <span  onMouseEnter={() => setAboutUsHover(true)}
                        onMouseLeave={() => setAboutUsHover(false)} className="custom-span">
                            About Us <FontAwesomeIcon icon={faChevronDown}  className="dropdown-arrow ms-2" style = {{fontSize: '18px'}}/>
                        </span>
                    }
                    id="aboutus-dropdown"
                    className="nav-dropdown-custom"
                    show={aboutUsHover}
                >
                    <NavDropdown.Item onClick={() => navigate('/corporate-governance')}>
                        Corporate Governance
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => navigate('/chairmans-message')}>
                        Chairman's Message
                    </NavDropdown.Item>
                </NavDropdown>

      {/**SECOND NAV HOV */}
    <NavDropdown
    title={
        <span  onMouseEnter={() => setStrategiesHover(true)}
                onMouseLeave={() => setStrategiesHover(false)} className="custom-span">
            Our Strategies <FontAwesomeIcon icon={faChevronDown} style = {{fontSize: '18px'}} className="dropdown-arrow ms-2" />
        </span>
    }

    id="strategies-dropdown"
    className="nav-dropdown-custom"
    show={strategiesHover}
>
    <NavDropdown.Item onClick={() => navigate('/opportunities')}>
        Opportunistic Investing
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/lending')}>
        Direct Lending
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/liquidity-solutions')}>
        Fund Liquidity Solutions
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/corporate-finance')}>
        Corporate Financing
    </NavDropdown.Item>
    <NavDropdown.Item onClick={() => navigate('/estate')}>
        Real Estate
    </NavDropdown.Item>
</NavDropdown>
      <Nav.Link id="nav-lks" style = {{color: '#b7944d'}} onClick={() => navigate('/team')}>Our Team</Nav.Link>
      <Nav.Link id="nav-lks"  onClick={() => navigate('/careers')}>Careers</Nav.Link>
      <Nav.Link id="nav-lks"  onClick={() => navigate('/contact-us')}>Contact Us</Nav.Link>

    </Nav>

  </Navbar.Collapse>
  </Container>
</Navbar>

{/* ====================== CUSTOM MOBILE SLIDE MENU ====================== */}
{/* ====================== FULL SCREEN MOBILE SLIDE MENU ====================== */}
<div className={`mobile-menu-fullscreen ${menuOpen ? 'active' : ''}`}>
  <div className="mobile-menu-overlay" onClick={() => setMenuOpen(false)}></div>
  <div className="mobile-menu-container">
    <button className="mobile-menu-close" onClick={() => setMenuOpen(false)}>×</button>

    <div className="mobile-menu-content">
      <Nav className="flex-column mobile-nav-stack">

        {/* About Us with Dropdown */}
<div className="mobile-dropdown-wrapper">
<div className="mobile-menu-item" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
  <span
    className="mobile-menu-text"
    onClick={() => { navigate('/abt'); setMenuOpen(false); }}
    style={{ flex: 1, cursor: 'pointer' }}
  >
    About Us
  </span>
  <span
    className={`dropdown-arrow ${mobileAboutOpen ? 'open' : ''}`}
    onClick={() => setMobileAboutOpen(!mobileAboutOpen)}
    style={{ cursor: 'pointer', marginLeft:'20px'}}
  >
    ▼
  </span>
</div>
{mobileAboutOpen && (
  <div className="mobile-sub-menu">
    <div className="sub-item" onClick={() => { navigate('/corporate-governance'); setMenuOpen(false); }}>
      Corporate Governance
    </div>
    <div className="sub-item" onClick={() => { navigate('/chairmans-message'); setMenuOpen(false); }}>
      Chairman's Message
    </div>
  </div>
)}
</div>

        {/* Our Strategies with Dropdown */}
        <div className="mobile-dropdown-wrapper">
          <div
          className="mobile-menu-item"
          onClick={() => setMobileStrategiesOpen(!mobileStrategiesOpen)}
          style={{ justifyContent: 'space-between', alignItems: 'center' }}
        >
          <span style={{ flex: 1, cursor: 'pointer' }}>
            Our Strategies
          </span>
          <span className={`dropdown-arrow ${mobileStrategiesOpen ? 'open' : ''}`}>▼</span>
        </div>
          {mobileStrategiesOpen && (
            <div className="mobile-sub-menu">
              <div className="sub-item" onClick={() => { navigate('/opportunities'); setMenuOpen(false); }}>
                Opportunistic Investing
              </div>
              <div className="sub-item" onClick={() => { navigate('/lending'); setMenuOpen(false); }}>
                Direct Lending
              </div>
              <div className="sub-item" onClick={() => { navigate('/liquidity-solutions'); setMenuOpen(false); }}>
                Fund Liquidity Solutions
              </div>
              <div className="sub-item" onClick={() => { navigate('/corporate-finance'); setMenuOpen(false); }}>
                Corporate Financing
              </div>
              <div className="sub-item" onClick={() => { navigate('/estate'); setMenuOpen(false); }}>
                Real Estate
              </div>
            </div>
          )}
        </div>

        {/* Our Team */}
        <div className="mobile-menu-item" onClick={() => { navigate('/team'); setMenuOpen(false); }}>
          Our Team
        </div>

        {/* Careers */}
        <div className="mobile-menu-item" onClick={() => { navigate('/careers'); setMenuOpen(false); }}>
          Careers
        </div>

        {/* Contact Us */}
        <div className="mobile-menu-item no-border" onClick={() => { navigate('/contact-us'); setMenuOpen(false); }}>
          Contact Us
        </div>

      </Nav>
    </div>
  </div>
</div>

      {/**hero section start*/}
      <Container fluid className="px-0" style={{
                marginTop: '6%',
                paddingTop: '80px',
                paddingBottom: '80px',
                backgroundColor: '#CD1C18',
                color: '#ffffff',
                overflow: 'visible', // Allows the image to overlap the bottom edge
                position: 'relative',
                zIndex: 1
            }}>
            <Row    style = {{paddingLeft: '3%', paddingRight: '3%'}}>
            <Col md = {6} xs={12} id="career-col-o">
            <Row id='career-txt'><span id='career-bar-f'></span> Our Team</Row>
            <Row id="ct">Expertise Across Asset Classes, Geographies and Market Cycles</Row>
          </Col>
          <Col id="border-t" md = {4} style={{ }}>
          <Image

              src={mul}
              id='img-main'
              alt="Shereen Logo"
          />
      </Col>
            </Row>
       </Container>
       {/**hero section end*/}

       <Container   >
        <Row   id='bal-row-t' >
            <Col md = {6} xs={12} id = 'balance-col-t'>Shereen’s team is led by ten partners who collectively bring more than two centuries of alternative investment management and multi-asset capital solutions experience.</Col>
            <Col></Col>
        </Row>
       </Container>

       {/**History */}
       <Container fluid style = {{backgroundColor: '#f8f8f8'}}>
                <Row  id = 'sheik-main' >
                    <Row  id='seasonal-row' >Seasoned Leadership with Decades of Industry Experience</Row>
                    <Row  id = 'sheik' >
                        <Col xs ={12} md = {3} id = 'sheik-col' >
                            <Row style = {{fontFamily: 'rufinaalt01', fontWeight: '700', fontSize: '18px', lineHeight: '27px', color: '#cd1c18'}}>Saud Al Saud</Row>
                            <Row  style = {{fontFamily: 'Lato', fontWeight: '700', fontSize: '18px', lineHeight: '27px', color: '#222b2f'}}>Chairman and CEO</Row>
                        </Col>
                        <Col xs ={12} md = {3}  id = 'sheik-col'>
                            <Row style = {{fontFamily: 'rufinaalt01', fontWeight: '700', fontSize: '18px', lineHeight: '27px', color: '#cd1c18'}}>Mohammed Al Mady</Row>
                            <Row  style = {{fontFamily: 'Lato', fontWeight: '700', fontSize: '18px', lineHeight: '27px', color: '#222b2f'}}>Vice Chairman</Row>
                        </Col>
                        <Col xs ={12} md = {3}  id = 'sheik-col' >
                            <Row style = {{fontFamily: 'rufinaalt01', fontWeight: '700', fontSize: '18px', lineHeight: '27px', color: '#cd1c18'}}>Khaled Nahhas</Row>
                            <Row  style = {{fontFamily: 'Lato', fontWeight: '700', fontSize: '18px', lineHeight: '27px', color: '#222b2f'}}>Chief Financial Officer</Row>
                        </Col>
                        <Col xs ={12} md = {3}  id = 'sheik-col' >
                            <Row style = {{fontFamily: 'rufinaalt01', fontWeight: '700', fontSize: '18px', lineHeight: '27px', color: '#cd1c18'}}>Hassan Abdullah</Row>
                            <Row  style = {{fontFamily: 'Lato', fontWeight: '700', fontSize: '18px', lineHeight: '27px', color: '#222b2f'}}>Funding Coordinator</Row>
                        </Col>
                    </Row>
                </Row>
       </Container>



      {/**end reach */}
      <Container  fluid className="px-0">
          <Row   style = {{marginTop: '1%'}}>
        {/* Card 1: Seeking Capital */}
        <Col lg={6} xs={12}>
            <Card
                className="cta-card"
                style={{
                    backgroundColor: '#24325B',
                    borderRadius: '0',
                    border: 'none',
                    height: '100%'
                }}
            >
                <Card.Body className="text-center py-5 px-4 px-md-5">
                    <Image src={ab} style={{ height: '32px' }} alt="mail" />

                    <h2 style={{
                        fontFamily: 'rufinaalt01',
                        fontWeight: '400',
                        fontSize: 'clamp(28px, 5.5vw, 48px)',
                        lineHeight: '1.15',
                        color: '#ffffff',
                        marginTop: '28px'
                    }}>
                        Interested in Seeking Capital
                    </h2>

                    <p style={{
                        fontFamily: 'Lato',
                        fontWeight: '400',
                        fontSize: 'clamp(18px, 4vw, 24px)',
                        lineHeight: '1.45',
                        color: '#ffffff',
                        maxWidth: '580px',
                        margin: '24px auto 0'
                    }}>
                        Contact us to learn how we apply creativity and flexibility to our capital solutions.
                    </p>

                    <div style={{ marginTop: '45px' }}>
                        <a
                            className="box"
                            href=""
                            onClick={() => navigate('/contact-us')}
                            style={{
                                border: '1px solid #f7f5f0',
                                padding: '18px 24px',
                                display: 'inline-block',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                transition: 'all 0.4s ease'
                            }}
                        >
                            <Image src={mp} alt="arrow" style={{ width: '26px' }} />
                        </a>
                    </div>
                </Card.Body>
            </Card>
        </Col>

        {/* Card 2: Join Our Team */}
        <Col lg={6} xs={12}>
            <Card
                className="cta-card"
                style={{
                    backgroundColor: '#CD1C18',
                    borderRadius: '0',
                    border: 'none',
                    height: '100%'
                }}
            >
                <Card.Body className="text-center py-5 px-4 px-md-5">
                    <Image src={ab} style={{ height: '32px' }} alt="mail" />

                    <h2 style={{
                        fontFamily: 'rufinaalt01',
                        fontWeight: '400',
                        fontSize: 'clamp(28px, 5.5vw, 48px)',
                        lineHeight: '1.15',
                        color: '#ffffff',
                        marginTop: '28px'
                    }}>
                        Join Our Team
                    </h2>

                    <p style={{
                        fontFamily: 'Lato',
                        fontWeight: '400',
                        fontSize: 'clamp(18px, 4vw, 24px)',
                        lineHeight: '1.45',
                        color: '#ffffff',
                        maxWidth: '580px',
                        margin: '24px auto 0'
                    }}>
                        Strong partnerships with customers start with the right colleagues.
                    </p>

                    <div style={{ marginTop: '45px' }}>
                        <a
                            className="box"
                            onClick={() => navigate('/careers')}
                            href=""
                            style={{
                                border: '1px solid #f7f5f0',
                                padding: '18px 24px',
                                display: 'inline-block',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                transition: 'all 0.4s ease'
                            }}
                        >
                            <Image src={mp} alt="arrow" style={{ width: '26px' }} />
                        </a>
                    </div>
                </Card.Body>
            </Card>
        </Col>
          </Row>
      </Container>

            {/**footer section */}
            <Container  fluid style ={{backgroundColor: '#efefef', fontFamily: 'Lato',  paddingBottom: '10px'}}> {/**marginRight: '2%' */}


            <Row id='ft-txt'> © Copyright 2026 Shereen Investment Company LLC</Row>
                                    <Row id= 'last-rw' className='d-md-none m-0 p-0'>
            <Col id='linkd' xs={12} onClick={() => navigate('/')}><FontAwesomeIcon icon={faLinkedin} className="me-2" /></Col>
                  </Row>




    </Container>

            {/*the below div is last div/ function component div*/}
          </div>
    )
}

export default Team;
